import { render, staticRenderFns } from "./ProgrammeSubjectSave.vue?vue&type=template&id=2dec3e7c&"
import script from "./ProgrammeSubjectSave.vue?vue&type=script&lang=js&"
export * from "./ProgrammeSubjectSave.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeSubjectSave.vue?vue&type=style&index=0&id=2dec3e7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports